<template><!--本地小吃-->
	<div>
		<jycheader :navIndex="2"></jycheader>
		<div class="switch">
			<el-carousel height="600px" :interval="3500" trigger="click">
				<el-carousel-item v-for="(item, index) in swiperData" :key="index">
					<img :src="item.picUrl" width="100%" height="100%" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="discount-layer">
			<div class="discount-layer-foor" v-for="(goodsList,index) in layer_data" :key="index">
				<div class="dis-between" style="width:100%;margin:20px auto 40px auto">
					<div></div>
					<div class="layer-header">
						<div class="bg" :style="'background-image: url('+goodsList.cover+')'"></div>
						<div class="tit">{{goodsList.name}}</div>
					</div>
					<div class="discount-p" @click="moreClick(goodsList.id)">更多</div>
				</div>
				<div class="layer-goods-list">
					<div class="goods-item marketlistbut2" v-for="(item, index) in goodsList.goodsList" :key="index">
						<router-link :to="{path:'details',query:{id:item.id, is_discount:4}}" class="pic">
							<img
								:src="item.cover"
								width="100%"
								height="100%"
							/>
						</router-link>
						<div class="goods_info">
							<div class="dis-between"><div class="name">{{item.name}}</div><div style="padding:0 10px;color:#ffffff;height: 24px;background: #57D887;border-radius: 5px;" v-if="item.goodsType == 2">{{item.integral}}积分</div></div>
							<div class="weight"></div><!--250g*1-->
							<div class="price">
								<span class="x_price">
									<span class="number">
										<span class="rmb">¥</span>
										<span class="p">{{item.price}}</span>元
									</span>
								</span>
							</div>
							<router-link
								class="a-button"
								:to="{path:'/famoussnacks_locality_list',query:{OneCategoryId:OneCategoryIdValue,TwoCategoryId:item.twoCategoryId, categoryId:item.categoryId}}"
							>查看更多</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<jycfooter></jycfooter>
	</div>
</template>

<script>
import jycheader from "../header.vue"
import jycfooter from "../bottom.vue"
import productApi from "./../../api/product"

export default {
	components: {
		jycheader,
		jycfooter
	},
	data() {
		return {
            is_wximg: false,
			layer_data: [],
            OneCategoryIdValue: 0,
            swiperData: [
                { picUrl: require( '../../assets/image/img/NewRegister/banner4.jpg' ) },
                { picUrl: require( '../../assets/image/img/NewRegister/banner.jpg' ) },
                { picUrl: require( '../../assets/image/img/NewRegister/banner2.jpg' ) },
                { picUrl: require( '../../assets/image/img/NewRegister/banner3.jpg' ) },
            ], //轮播图
		}
	},
    created() {
        this.getBanner()
        this.authMarketAddressFn()
        this.MMCProductCategoryTree()
    },
	mounted() {
        window.scroll(0, 0)
		this.initalize()
        this.is_wximg = true
	},
	methods: {
		async initalize() {
			this.$loading()
            let cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
            // let addId = {
            //     "cityId":cityname.twoId,
            //     "regionId":cityname.threeId > 0?cityname.threeId: null
            // }
            let addId = {}
			let { data } = await productApi.GetBDXCCategoryShopGoodList(addId)
			let { code, result } = data

			if (code == 0) {
				this.layer_data = result
			}
			this.$loading().close()
		},
        closeWxClick() {
            this.is_wximg = false
        },
        MMCProductCategoryTree() {
            productApi.BDXCProductCategoryTree().then( res =>
            {
                // console.log(res.data)
                if ( res.data.code == 0 )
                {
                    let data = res.data.result;
                    this.OneCategoryIdValue = data[0].id
                }
            })
        },
        // +----------------------------------------
        authMarketAddressFn() {
            let that = this
            // if ( !localStorage.getItem('token') )
            // {
            //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
            //     {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     } ).then( () =>
            //     {
            //         this.$router.push({path: '/login'})
            //     } ).catch( () =>
            //     {
            //         // ...
            //     } )
            //     return 1
            // }
            if (!JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                this.$confirm( '请选择收货地址？', '提示',
                {
                    confirmButtonText: '前往选择',
                    showCancelButton: false,
                    showClose: false,
                    closeOnClickModal: false,
                    // cancelButtonText: '取消',
                    type: 'warning'
                }).then( () =>
                {
                    localStorage.setItem( 'isSetOneAddress', 1 )
                    that.$router.push( { path: '/marketlist?num=2' } )
                }).catch( () =>
                {
                    // ...
                })

                return 1
            }
        },
        // +----------------------------------------
		moreClick(id) {
			this.$router.push({
				path: "/famoussnacks_locality_list",
				// query: { OneCategoryId: id }
                query: {OneCategoryId: this.OneCategoryIdValue, TwoCategoryId: id}
			})
		},
        getBanner()
        {
            //获取轮播图
            let params = {
                PageNo: 1,
                PageSize: 10,
                Params:
                {
                    type: 2,
                },
            };
            this.$api.product.getindexBanner( params ).then( ( res ) =>
            {
                if ( res.data.code == 0 )
                {
                    console.log( res.data.result.data )
                    if ( res.data.result.data.length > 0 ) this.swiperData = res.data.result.data;
                }
                else
                {
                    this.$message(
                    {
                        message: res.data.message,
                        type: "warning",
                    } );
                }
            } );
        },
	}
}
</script>
<style scoped>
.switch {
	width: 1200px;
	margin: 22px auto 40px;
	border-radius: 20px;
	overflow: hidden;
}

.discount-layer {
	width: 1200px;
	margin: 0 auto;
}

.layer-header {
	width: 310px;
	height: 90px;
	background: #f7f7f7;
	border-radius: 45px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 15px 33px;
	margin: 20px auto 40px;
}

.layer-header .bg {
	width: 61px;
	height: 59px;
	background-repeat: no-repeat;
	background-size: 100%;
}

/* .discount-layer-foor:nth-child(1) .bg {
        background-image: url('../../assets/image/img/折扣页/xia.png');
    }

    .discount-layer-foor:nth-child(2) .bg {
        background-image: url('../../assets/image/img/折扣页/roulei.png');
    }

    .discount-layer-foor:nth-child(3) .bg {
        background-image: url('../../assets/image/img/折扣页/shuiguo.png');
    }

    .discount-layer-foor:nth-child(4) .bg {
        background-image: url('../../assets/image/img/折扣页/tecan.png');
    }

    .discount-layer-foor:nth-child(5) .bg {
        background-image: url('../../assets/image/img/折扣页/shucai.png');
    } */

.layer-header .tit {
	font-size: 36px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #11d165;
	flex: 1;
	margin-left: 35px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.layer-goods-list {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
}

.goods-item {
	width: 590px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 20px 17px;
	background: #f7f7f7;
	border-radius: 20px;
	margin-bottom: 20px;
}

.goods-item .pic {
	width: 180px;
	height: 180px;
	display: block;
}

.goods-item .goods_info {
	flex: 1;
	margin-left: 45px;
}

.goods-item .goods_info .name {
	font-size: 20px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #434343;
	margin-bottom: 13px;
}

.goods-item .goods_info .weight {
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #ff4949;
	margin-bottom: 20px;
}

.goods-item .price {
	margin-bottom: 20px;
}

.goods-item .price .x_price {
	margin-right: 70px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #ff4949;
}

.goods-item .price .x_price span.tip {
	background: #d9161c;
	border-radius: 5px;
	font-size: 14px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #ffffff;
	padding: 3px 3px;
}

.goods-item .price .x_price span.rmb {
	font-size: 18px;
}

.goods-item .price .x_price span.p {
	font-size: 22px;
}

.goods-item .price .o_price {
	font-family: PingFang SC;
	font-weight: 500;
	text-decoration: line-through;
	color: #999999;
}

.goods-item .price .o_price .rmb {
	font-size: 18px;
}

.goods-item .price .o_price .p {
	font-size: 16px;
}

.a-button {
	display: block;
	width: 300px;
	height: 44px;
	line-height: 44px;
	background: #d9161c;
	border-radius: 5px;
	text-align: center;
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #ffffff;
}

/* // goods-item */
</style>

<style>
.switch .el-carousel__indicators {
	bottom: 29px;
	left: auto;
	right: 0px;
	background: rgba(247, 247, 247, 0.3);
	border-radius: 10px;
}

.switch .el-carousel__indicators .el-carousel__indicator--horizontal {
	padding: 4px 12px;
}

.switch .el-carousel__indicators .el-carousel__button {
	background-color: #fff;
	border-radius: 50%;
	width: 12px;
	height: 12px;
}

.switch .el-carousel__indicators .el-carousel__indicator.is-active button {
	background: #11d165;
}
@import "../../assets/style/base.css";
</style>